var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeader2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1440 293"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7289DA",
  d: "M1447.27-6.188v138.753c-18.44 98.559-68.33 159.978-332.79 159.978-339.321 0-637.477-286.793-1120.87-60.03v-238.7z"
})));
export default SvgHeader2;